import type { IconData } from '@stacksjs/iconify-core'

export const speakerF: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M3 0h8a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m4 17a4 4 0 1 0 0-8a4 4 0 0 0 0 8M7 7a1 1 0 1 0 0-2a1 1 0 0 0 0 2m0 8a2 2 0 1 1 0-4a2 2 0 0 1 0 4\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default speakerF
